import '@fancyapps/fancybox';
import initIntroSlider from './components/introSlider';
import initValidationForm from './components/formValidation';
import initFakeSelect from './components/fake-select-openClose';
import {initCategoryOpenClose, initMobileFiter} from './components/category-openClose';
import initRelatedSlider from './components/related-slider';
import initProductTabs from './components/productTabs';
import {initCartPopup, initScrollHeight} from './components/cartPopup';
import initSingleProductSlider from './components/single-product-slider';
import initDetailsPopup from './components/detailsPopup';
import initCountProduct from './utils/customInputNumber';
import initHorizontalSlider from './components/horizontal-slider';
import initVideo from './components/youTubeVideo';
import initPrice from './components/price';
import initColorPicker from './components/colorPicker';
import initDescriptionAccordion from './components/detail-accordion';

import './jquery.serializejson';
import './naturanimo';
import './chadog';
import './riashop/catalog';
import './riashop/newsletter';
import './riashop'


function initFancybox() {
  jQuery('a.lightbox:not(.init), [data-fancybox]:not(.init)').each(function(){
    $(this).addClass('init');

    $(this).click(function(){
      if( $(this).data('fancybox') == 'gallery' ){
        return;
      }

      var indexed_array = $(this).parents('form').serializeJSON();

      $.fancybox.open({
        src: $(this).data('src'),
        type: $(this).data('type'),
        parentEl: 'body',
        margin: [50, 0],
        lang: 'fr',
        i18n: {
          fr: {
            CLOSE: 'Fermer',
            NEXT: 'Prochain',
            PREV: 'Précédent',
            ERROR: 'Le contenu demandé ne peut pas être chargé. <br/> Veuillez réessayer plus tard.',
            PLAY_START: 'Lancer le diaporama',
            PLAY_STOP: 'Suspendre le diaporama',
            FULL_SCREEN: 'Plein écran',
            THUMBS: 'Vignettes',
            DOWNLOAD: 'Télécharger',
            SHARE: 'Partager',
            ZOOM: 'Zoom',
          },
        },
        ajax: {
          settings: {
            data: indexed_array
          }
        }
      });
    });
  });
}

function initCloneReviews() {
  const element = jQuery('.js-clone-target');
  const holder = jQuery('.js-clone-parent');

  if (element && holder) {
    const cloneElement = element.clone().addClass('clone');
    cloneElement.appendTo(holder);
  }
}

function initFileInputView() {
  jQuery('.custom-file-input').on('change', function () {
    const fileName = jQuery(this).val().split('\\').pop();
    jQuery(this).siblings('.custom-file-label').addClass('selected').html(fileName);
  });
}

window.onload = function () {
  if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
  }

  initIntroSlider();
  initFancybox();
  initValidationForm();
  initCartPopup();
  initScrollHeight();
  initFakeSelect();
  initMobileFiter();
  initRelatedSlider();
  initSingleProductSlider();
  initProductTabs();
  initCloneReviews();
  initCountProduct();
  initDetailsPopup();
  initHorizontalSlider();
  initVideo();
  initFileInputView();
  initPrice();
  initColorPicker();
  initDescriptionAccordion();

  const $=a=>document.querySelector(a),countdown=function(a){let d=$(a.target).getAttribute("data-date").split("-"),g=parseInt(d[0]),h=parseInt(d[1]),i=parseInt(d[2]),c=$(a.target).getAttribute("data-time"),e,f;null!=c&&(e=parseInt((c=c.split(":"))[0]),f=parseInt(c[1])),new Date().getFullYear();let b=new Date;b.getDate(),b.getMonth(),b.getFullYear(),b.getHours(),b.getMinutes();let k=new Date(i,h-1,g,e,f,0,0).getTime();$(a.target+" .day .word").innerHTML=a.dayWord,$(a.target+" .hour .word").innerHTML=a.hourWord,$(a.target+" .min .word").innerHTML=a.minWord,$(a.target+" .sec .word").innerHTML=a.secWord;let j=()=>{let c=new Date().getTime(),b=k-c;requestAnimationFrame(j),$(a.target+" .day .num").innerHTML=addZero(Math.floor(b/864e5)),$(a.target+" .hour .num").innerHTML=addZero(Math.floor(b%864e5/36e5)),$(a.target+" .min .num").innerHTML=addZero(Math.floor(b%36e5/6e4)),$(a.target+" .sec .num").innerHTML=addZero(Math.floor(b%6e4/1e3)),b<0&&($(".countdown").innerHTML="")};j()},addZero=a=>a<10&&a>=0?"0"+a:a;

  if( document.getElementsByClassName('countdown').length ){
    const myCountdown = new countdown({ target: '.countdown', dayWord: ' J ', hourWord: ' H ', minWord: ' M ', secWord: ' S ' });
  }
};
